<template>
  <chartjs-wrapper
    ref="chartJsWrapper"
    class="white"
    chartId="priceHistoryChart"
    :chart-data="priceHistoryChartData"
    :type="'line'"
    :options="priceHistoryChartOptions"
    :chart-height="30"
    hover-line
  >
  </chartjs-wrapper>
</template>

<script>
import definitions from '../../../definitions'
import _ from 'lodash'
import DateRangeChartMixin from '@/components-internal/mixins/DateRangeChartMixin.js'
import convertHex from '@/classes-internal/utils/convertHex'

export default {
  name: 'PriceHistoryChart',

  mixins: [DateRangeChartMixin],

  props: {
    /**
     * The raw chart data
     */
    priceHistoryData: {
      type: Array,
      required: true,
    },

    /**
     * The selected product
     * definitions the chart
     * contains data for
     */
    selectedProductDefinitions: {
      type: Array,
      required: true,
    },
  },

  computed: {
    priceHistoryChartData() {
      const linesData = _.groupBy(this.priceHistoryData, 'productDefinitionId')
      const data = {
        datasets: Object.keys(linesData).map((productDefinitionId) => {
          const productCategory = linesData[productDefinitionId]
          const selection = _.find(
            this.selectedProductDefinitions,
            function (selection) {
              return selection.item.id === parseInt(productDefinitionId)
            }
          )

          const backgroundColor = convertHex(selection?.color, 10)

          return {
            borderColor: selection?.color,
            borderWidth: definitions.globalChartSettings.borderWidth,
            backgroundColor,
            fill: '+1',
            pointRadius: definitions.globalChartSettings.pointRadius,
            pointBackgroundColor: productCategory.map((product) =>
              product.isCustomPrice()
                ? definitions.colors.named.overwritten
                : selection?.color
            ),
            pointBorderColor: productCategory.map((product) =>
              product.isCustomPrice()
                ? definitions.colors.named.overwritten
                : selection?.color
            ),
            data: productCategory.map((product) => ({
              x: product.calculatedAt,
              y: product.getChartFormattedPrice(),
            })),
            label: selection?.item?.getTranslatedName(),
          }
        }),
      }

      return data
    },
    priceHistoryChartOptions() {
      const mainOptions = {
        responsive: true,
        layout: {
          padding: {
            right: 70,
          },
        },
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: (tooltipItems, data) => {
              return (
                data.datasets[tooltipItems.datasetIndex].label +
                ': ' +
                tooltipItems.yLabel +
                ` ${store.getters
                  .getCurrentDestinationInstance()
                  .getCurrency()}`
              )
            },
          },
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString:
                  this.$t('currentPostedPricesChart.ylabel') +
                  ` (${store.getters
                    .getCurrentDestinationInstance()
                    .getCurrency()})`,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
              type: 'time',
              ticks: {
                maxTicksLimit: 10,
              },
              time: {
                tooltipFormat: 'ddd - DD.MM.YYYY',
                unit: 'day',
              },
            },
          ],
        },
        legend: {
          display: true,
          labels: {
            usePointStyle: true,
          },
        },
      }
      return _.merge(this.baseChartOptions, mainOptions)
    },
  },
  watch: {
    // needed to update the vertical selcted date line
    productTargetPricesChartOptions() {
      this.$refs.chartJsWrapper.reCreateChart()
    },
  },
}
</script>
